import type {AxiosRequestConfig, AxiosResponse} from "axios";



import CoreApi from "@/src/modules/core/api";

import axios from "@/src/modules/core/lib/axios";

import {useSessionStore} from "@/src/modules/auth/store/session";

import type {GetResponse} from "@/src/modules/core/types";



import {getAdminTokenBackup} from "../lib/impersonation-session";

import type {

  EndImpersonationResult,

  ImpersonationStatus,

  StartImpersonationPayload,

  StartImpersonationResult,

} from "../types";



const BASE = "support/impersonate";



/** Status: admin backup when impersonating, otherwise current admin session token. */

function adminBearerForStatus(): AxiosRequestConfig {
  const adminBackup = getAdminTokenBackup();
  const sessionToken = useSessionStore.getState().session?.access_token;
  const token = adminBackup ?? sessionToken;

  return token ? {headers: {Authorization: `Bearer ${token}`}} : {};
}



/** Start: current admin session, or stored admin backup if session was already swapped. */

function adminBearerForStart(): AxiosRequestConfig {

  const adminBackup = getAdminTokenBackup();

  const sessionToken = useSessionStore.getState().session?.access_token;

  const token = adminBackup ?? sessionToken;



  return token ? {headers: {Authorization: `Bearer ${token}`}} : {};

}



class SupportImpersonateApi extends CoreApi {

  getStatus(): Promise<AxiosResponse<GetResponse<ImpersonationStatus>>> {

    return axios.get(`${BASE}/status`, adminBearerForStatus());

  }



  start(

    payload: StartImpersonationPayload,

  ): Promise<AxiosResponse<GetResponse<StartImpersonationResult>>> {

    return axios.post(`${BASE}/start`, payload, adminBearerForStart());

  }



  end(): Promise<AxiosResponse<GetResponse<EndImpersonationResult>>> {

    return super.post(`${BASE}/end`, {});

  }

}



export const supportImpersonateApi = new SupportImpersonateApi();


